import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Billing, BillingCustomCService, BillingService } from '@eadsysteme/billingclient-v1';
import { catchError, EMPTY, forkJoin, Observable, of, switchMap } from 'rxjs';
import { SnackbarService } from './snackbar.service';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
	providedIn: 'root',
})
export class BillingHelper {
	private readonly destroyRef = inject(DestroyRef);
	private readonly billingService = inject(BillingService);
	private readonly billingCustomCService = inject(BillingCustomCService);
	private readonly translocoService = inject(TranslocoService);
	private readonly snackBar = inject(SnackbarService);

	public syncRealEstateBillings(realEstateArea: number, realEstateId: string): Observable<any[]> {
		if (!realEstateArea || !realEstateId) {
			return EMPTY;
		}
		return this.billingCustomCService.getBillingsByRealEstate(realEstateArea, realEstateId).pipe(
			switchMap((billings: Billing[]) =>
				billings.length > 0
					? forkJoin(
							billings
								.filter((billing) => billing?.portalActive)
								.map((billing) =>
									this.billingService.syncTenantUnitReferencesBilling(realEstateArea, billing.exportId).pipe(
										catchError(() => {
											this.snackBar.error(this.translocoService.translate('errors.synchronizingTenantUnitReferences'));
											return of(null);
										})
									)
								)
						)
					: of([])
			),
			takeUntilDestroyed(this.destroyRef)
		);
	}

	public syncBilling(area: number, billingExportId: string) {
		this.billingService
			.syncTenantUnitReferencesBilling(area, billingExportId)
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe({
				next: () => {
					this.snackBar.success(this.translocoService.translate('billing.synchronizedTenantUnitReferences'));
				},
				error: () => {
					this.snackBar.error(this.translocoService.translate('errors.synchronizingTenantUnitReferences'));
				},
			});
	}
}
